import { render } from "./ShroffIncome.vue?vue&type=template&id=f2c2db92"
import script from "./ShroffIncome.vue?vue&type=script&lang=js"
export * from "./ShroffIncome.vue?vue&type=script&lang=js"

import "./ShroffIncome.vue?vue&type=style&index=0&id=f2c2db92&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__